import React, { useState, useContext, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Link, useHistory, useLocation } from 'react-router-dom';
import { Dropdown } from 'react-bootstrap';
import debounce from 'lodash/debounce';
import { globalConfigContext } from '@context/GlobalConfigContext';
import userService from '@apiService/userService';

export default function NationalityDropdown({
  className,
  onSelectCountry,
  nationalityData,
  isPrivate = false,
  ...props
}) {
  const globalOptions = useSelector((state) => state.movies.globalOptions);
  const [countries, setCountries] = useState(null);
  const [countriesCopy, setCountriesCopy] = useState(null);
  const [selectedCountryCode, setSelectedCountryCode] = useState('');
  const [selectedCountryId, setSelectedCountryId] = useState('');
  const [selectedNationalityName, setSelectedNationalityName] = useState(
    'Select Your Nationality',
  );

  const [countryCodeSearch, setCountryCodeSearch] = useState('');
  const { pathname } = useLocation();

  const { loggedInUser, guestUser } = useSelector((state) => state.auth);
  const userData = window.localStorage.getItem('user')
    ? JSON.parse(window.localStorage.getItem('user'))
    : {};

  useEffect(() => {
    if (nationalityData && nationalityData?.length > 0)
      setCountries(nationalityData);
    setCountriesCopy(nationalityData);
    if (userData && userData?.customer_nationality) {
      let selectedNationName = nationalityData?.find((data) => {
        return data?.nationality_id == userData?.customer_nationality;
      })?.nationality;
      setSelectedNationalityName(selectedNationName);
    }
  }, [nationalityData]);

  useEffect(() => {
    if (countryCodeSearch && countryCodeSearch.length > 0) {
      let newCountries = countries.filter(
        (c) =>
          c?.nationality_country_code?.includes(countryCodeSearch) ||
          c?.nationality?.toLowerCase()?.includes(countryCodeSearch.toLowerCase()),
      );
      setCountriesCopy(newCountries);
    } else {
      setCountriesCopy(countries ? [...countries] : []);
    }
  }, [countryCodeSearch]);

  const handleCountrySelect = ({
    nationality_country_code,
    nationality_id,
    nationality,
  }) => {
    setSelectedCountryCode(nationality_country_code);
    setSelectedCountryId(nationality_id);
    setSelectedNationalityName(nationality);
    if (onSelectCountry) {
      onSelectCountry({ nationality_id, nationality_country_code, nationality });
    }
  };

  return (
    <div className={`code ${className}`}>
      <Dropdown className="">
        <Dropdown.Toggle className="dropdownClassic p-0" id="dropdown-basic">
          <span className="code" id="code_country_input">
            {selectedNationalityName
              ? selectedNationalityName
              : selectedCountryCode
              ? selectedCountryCode
              : userData && userData?.CountryCode
              ? userData?.CountryCode
              : ''}
          </span>
        </Dropdown.Toggle>

        <Dropdown.Menu align="right" className="dropdownItems national_input">
          <Dropdown.Item className={`selected ${isPrivate && ' dropdown-golden '}`}>
            <input
              className={`h-auto py-2 ${
                className.includes('form-control') && 'form-control'
              } ${pathname === '/user-profile' && 'mb-0'}`}
              type="text"
              value={countryCodeSearch}
              onChange={(e) => setCountryCodeSearch(e.target.value)}
              placeholder="Search"
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                return;
              }}
            />
          </Dropdown.Item>
          {countriesCopy?.map((country, i) => (
            <Dropdown.Item
              key={`${country.nationality}-${i}`}
              className={`selected ${isPrivate && ' dropdown-golden '}`}
              id="country_code_dropdown"
              onClick={() => handleCountrySelect(country)}
            >
              {country.nationality}
            </Dropdown.Item>
          ))}
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );
}
